export default [
    {
      path: '/admin/whole-sales',
      name: 'wholesale',
      meta: { requiresAuth: true },
      component: () => import('@/pages/wholesale/index-v2.vue')
    },
    {
      path: '/admin/whole-sales/create',
      name: 'wholesale-create',
      meta: { requiresAuth: true },
      component: () => import('@/pages/wholesale/create.vue')
    },
    {
      path: '/admin/whole-sales/:id/edit',
      name: 'wholesale-edit',
      meta: { requiresAuth: true },
      component: () => import('@/pages/wholesale/edit.vue')
    }
  ]
  